"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PowerSavingIcon = void 0;
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var PowerSavingIcon = function PowerSavingIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "4.8",
    y: "20.2",
    width: "15.3022",
    height: "8.68571",
    rx: "2.05707",
    transform: "rotate(-90 4.8 20.2)",
    fill: "#13131C",
    stroke: "#13131C",
    "stroke-width": "1.6"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.31536 1.99992C10.3391 1.99992 10.7515 2.41089 10.9176 2.74199C11.0237 2.95355 10.8378 3.15234 10.6011 3.15234H8.02965C7.79295 3.15234 7.60699 2.95355 7.71313 2.74199C7.87925 2.41089 8.29164 1.99992 9.31536 1.99992Z",
    fill: "#13131C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18 14C18 17.3137 15.3137 20 12 20C8.68629 20 6 17.3137 6 14C6 10.6863 8.68629 8 12 8C15.3137 8 18 10.6863 18 14Z",
    fill: "white",
    stroke: "#68686E",
    "stroke-width": "1.6"
  }), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask0_403_54103",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: "6",
    y: "8",
    width: "12",
    height: "12"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.7 14C16.7 16.5957 14.5957 18.7 12 18.7C9.40426 18.7 7.3 16.5957 7.3 14C7.3 11.4043 9.40426 9.3 12 9.3C14.5957 9.3 16.7 11.4043 16.7 14Z",
    fill: "white",
    stroke: "#13131C"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask0_403_54103)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.19037 17.91C8.07403 17.7939 8.01586 17.6461 8.01586 17.4667C8.01586 17.2872 8.07403 17.1395 8.19037 17.0234L8.71391 16.5009C8.4918 16.1948 8.31729 15.8545 8.19037 15.48C8.06346 15.1051 8 14.7118 8 14.3001C8 13.2446 8.37017 12.3449 9.11052 11.6009C9.85087 10.8566 10.7499 10.4897 11.8075 10.5002H15.5991V14.3001C15.6203 15.3556 15.2581 16.2528 14.5127 16.9917C13.7669 17.7306 12.8651 18.1 11.8075 18.1C11.395 18.1 11.0009 18.0367 10.6253 17.91C10.25 17.7833 9.90904 17.6092 9.60232 17.3875L9.07879 17.91C8.96245 18.0261 8.81438 18.0842 8.63458 18.0842C8.45478 18.0842 8.30671 18.0261 8.19037 17.91ZM11.8075 16.8334C12.5161 16.8334 13.119 16.5853 13.6161 16.0892C14.1131 15.5931 14.3511 14.9968 14.33 14.3001V11.7669H11.8075C11.1095 11.7563 10.5119 11.9991 10.0148 12.4952C9.51771 12.9913 9.26917 13.5929 9.26917 14.3001C9.26917 14.5429 9.29814 14.7724 9.3561 14.9885C9.41448 15.2051 9.50185 15.4084 9.61819 15.5984L11.3633 13.8568C11.4796 13.7407 11.6277 13.6826 11.8075 13.6826C11.9873 13.6826 12.1354 13.7407 12.2517 13.8568C12.368 13.9729 12.4262 14.1207 12.4262 14.3001C12.4262 14.4795 12.368 14.6273 12.2517 14.7434L10.5066 16.485C10.697 16.6012 10.9007 16.6883 11.1177 16.7466C11.3343 16.8044 11.5642 16.8334 11.8075 16.8334Z",
    fill: "#13131C"
  }))));
};
exports.PowerSavingIcon = PowerSavingIcon;